export default "__VITE_ASSET__BZvZcXsa__"